import Main from "./Main";
import processDataset from "../utils/process-dataset/process-dataset";
import { G_elements } from "../utils/globals/elements";

/**
 * Initializes the Main object
 * @this {MainClassProps}
 * @param {Object} options
 * @returns {MainClassProps}
 */
Main.prototype.init = function (options) {
  /** Reset to defaults */
  this.defaults();

  /** Element is visible at the beginning */
  this.visible = true;

  /** Dataset `data-tor` */
  this.dataset = this.element.dataset.tor || "";

  /** Current element's style */
  this.computedStyle = getComputedStyle(this.element);

  /** `this.element.style` ref */
  this.style = this.element.style;

  /** Optimized dataset string */
  this.attributes = processDataset(this);

  /** Main store of triggers and timelines */
  this.createStore();

  /** Process storage with flat parameters */
  this.processStorage();

  /** Add trigger event names with callback function (`pointerenter`) into the `this.events` map */
  this.addEvents();

  /** Add custom `addEventListener` listener with callback function from `this.events` */
  this.addListeners();

  /** Add element with reference to `this` into the global map */
  G_elements.set(this.element, this);

  /** Return class */
  return this;
};

export default Main.init;
